import React from 'react'
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const AboutTakaful = () => {
  const {t} = useTranslation();
  return (
    <div>
      <Container className="smeBottomBox">
        <div className="row">
          <div className='col-md-6'>
            <p className="aboutPlatform me-1 me-xxl-5 px-2 py-3 py-md-5 mb-0">
              {t("takaful_bazaar")} <span> {t("sme_about_takaful_paragraph_a")}</span>  {t("sme_about_takaful_paragraph_b")}
            </p>
          </div>
          <div className='col-md-6 align-content-center'>
            <div className="row py-3 py-md-5 text-center">
              <div className="col-6 borderRight">
                <h5 className="pricingSME">{t("sme_about_takaful_three_hundred_plus_heading")}</h5>
                <h6 className="SMEcoverages">{t("sme_about_takaful_corporates_covered_heading")}</h6>
              </div>
              <div className="col-6">
                <h5 className="pricingSME">{t("sme_about_takaful_four_lacks_plus_heading")}</h5>
                <h6 className="SMEcoverages">{t("lives_covered")}</h6>  
              </div>
            </div>
          </div>
        </div>
    </Container>
    </div>
  )
}

export default AboutTakaful